import React from 'react';
import type { ReactNode } from 'react';
type SectionTone = 'canvas' | 'surface' | 'ink';
interface SectionProps {
  children: ReactNode;
  id?: string;
  tone?: SectionTone;
  bordered?: boolean;
  className?: string;
  labelledBy?: string;
}
const toneClasses: Record<SectionTone, string> = {
  canvas: 'bg-canvas text-ink',
  surface: 'bg-surface text-ink',
  ink: 'bg-ink text-white'
};
export function Section({
  children,
  id,
  tone = 'canvas',
  bordered = false,
  className = '',
  labelledBy
}: SectionProps) {
  return <section id={id} aria-labelledby={labelledBy} className={`${toneClasses[tone]} ${bordered ? 'border-t border-hairline' : ''} py-section-sm lg:py-section ${className}`} data-id="element-790" data-mp="he87rrr58gaw">
      {children}
    </section>;
}